const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/PageCard/PageCardComponent.tsx';
import React, { ReactNode } from 'react';
import { Card, Icon, Typography, TypographyProps } from '@mui/material';
import { css, cx } from '@emotion/css';
import { theme } from 'App/utils/clientSetupManager';

const cardTitleStyle = css`
    padding: 10px 24px;
    color: ${theme.palette.primary.contrastText};
    background-color: ${theme.palette.primary.main};
    display: flex;
    align-items: center;
    margin-bottom: 0;
`;

const iconStyle = css`
    margin-right: 10px;
`;

type PageCardComponentProps = {
    children?: any;
    title?: ReactNode;
    titleIcon?: string;
    TitleProps?: TypographyProps;
    hideBackBtn?: boolean;
};

const PageCardComponent = (props: PageCardComponentProps) => {
    return (
        <Card>
            {props.title && (
                <Typography
                    variant="subtitle1"
                    component="div"
                    gutterBottom
                    className={cx(cardTitleStyle, props.TitleProps?.className)}
                >
                    {props?.titleIcon && <Icon className={cx(props.titleIcon, iconStyle)} />}
                    <span>{props.title}</span>
                </Typography>
            )}
            {props.children}
        </Card>
    );
};

export default PageCardComponent;
